__turbopack_context__.v({
  "dropzone": "ImageDropzone-module-scss-module__0T1XIa__dropzone",
  "error": "ImageDropzone-module-scss-module__0T1XIa__error",
});
